// extracted by mini-css-extract-plugin
export default {"container":"LoadingIcon_container__HAdo1","lds-dual-ring":"LoadingIcon_lds-dual-ring__Lp9qY"};